<template>
    <el-drawer
        :title="formData.id ? '修改链接' : '生成链接'"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                size="medium"
            >
                
                <el-form-item prop="urlPath" label="链接地址:">
                    <el-input v-model="formData.urlPath" placeholder="请输入小程序页面路径" maxlength="200"></el-input>
					<div class="color-warning MT20">
						<small>
							功能说明:<br>
							1.本功能是调用微信小程序官方提供的“generateUrlLink”接口用于生成在短信中拉起微信小程序的业务<br>
							2.如果要定向跳转微信小程序指定演出详情页，请输入演出的页面路径生成链接
						</small>
					</div>
                </el-form-item>
                
                
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >生成链接</el-button
            >
        </div>
    </el-drawer>
</template>
<script>
const defaultData = {
    urlPath: ""
}
export default {
    
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            dataLoading: false,
            formData:{
                ...defaultData
            },
            
            rules:{               
                urlPath:[{ required: true, message: "请填写小程序页面路径" }]
            },
        }
    },
    methods:{
        close(){
            this.$refs.formData.resetFields();
            this.drawerShow = false;
            this.formData = {
                ...defaultData
            }
        },
        show(obj){
            if( obj ){
                this.formData = {
                    ...obj
                };
            }
            this.drawerShow = true;
        },
        
        submitForm(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;    
                    this.$request({
                        url: '/applet/link/generate',
                        data: {...this.formData},
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });   
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>